import { memo, useEffect, useState } from "react";
import "../index.scss";
import CustomScroll from '@src/component/customScroll'
import { Form, Input, Toast } from "antd-mobile";
import PickerPopup from "../../../component/PickerPopup";
import { getCalVal, hasLoanAndQuaStatus } from "@src/service/ownService";
import { goto } from "@src/route";
import BottomIcon from '@src/component/bottomIcon'
import store from '@src/util/store'
import { isEmpty } from "@src/util";
const Calculator = () => {

  const [visible, setVisible] = useState<boolean>(false);//picker是否显示
  const [val, setVal] = useState<number[]>([]); //首付比例与期数值
  const [carPrice, setPrice] = useState<string>(""); //裸车价格
  const [isShow, setShow] = useState<boolean>(false); //是否显示计算结果
  const [calObj, stCalObj] = useState<any>();
  const [timer, setTimer] = useState<any>(null);

  useEffect(() => {
    setPrice(store.get('cheliang')?.salePrice || '')
    document.title = "金融计算器"
  }, [])

  useEffect(() => {
    if ((val[0] || val[0] == 0) && val[1] && carPrice) {

      if (timer) {
        clearTimeout(timer);
        setTimer(null);
      }
      setTimer(setTimeout(() => {
        getCal();
      }, 500));
    }
  }, [val, carPrice])

  //金融计算器计算
  const getCal = async () => {
    const serObj = {
      carPrice: Number(carPrice),
      downPayment: val[0],
      stagingTime: val[1]
    }
    Toast.show({
      icon: 'loading',
      content: '加载中…',
      duration: 0,
      maskClickable: false
    })
    try {
      const newData = await getCalVal(serObj);
      stCalObj(newData);
      setShow(true);
      Toast.clear()
    } catch (err: any) {
      Toast.show(err?.errmsg || '');
    }
  }

  // 查看一个预审状态
  const quaResult = async () => {

    try {
      Toast.show({
        icon: 'loading',
        content: '加载中…',
        duration: 0,
        maskClickable: false
      })
      const { code } = await hasLoanAndQuaStatus() || {};
      Toast.clear()
      if (code === 999) {
        Toast.show('您已有业务办理成功，暂不支持新的业务办理')
      }
      // 当前无业务
      else if ([0, 1, 2, 3, 4, 9].includes(code)) {
        goto('/rzStatus');
      }
      // 进入资格预审
      else {
        goto("/uploadId");
      }
    } catch (err: any) {
      Toast.show(err?.errmsg || '状态查询失败')
    }
  }

  // input 输入
  const changeInput = (val: any) => {
    if (!isNaN(Number(val))) {
      const floatNum = val.split('.')[1]?.length;
      if (floatNum > 2) {
        return;
      }
      setVal([]);
      setPrice(val)
      setShow(false)
    }
  }

  return (
    <div className="page bottomFit Calcul">
      <CustomScroll>
        <div className="Calculator">
          <header>
            <div className="header-box">
              <div className="header-title">
                <div className="header-text">
                  <p className="dotted-line">分期计算器</p>
                  <span>您可以修改数据以查看适合您的金融方案</span>
                </div>
              </div>
              <div className="header-content inputForm">
                <Form layout='horizontal'>
                  <div className="more-unit">
                    <Form.Item label="裸车价格：">
                      <Input maxLength={20} type="number" onChange={changeInput} value={carPrice} placeholder='请输入裸车价格' />
                    </Form.Item>
                  </div>
                  <div className="more-xia">
                    <Form.Item label="首付比例："  arrow={false} onClick={() => { setVisible(true)  }} >
                      <Input readOnly placeholder='请选择首付比例' value={`${isEmpty(val[0])?'':(val[0]*100).toFixed(0)+'%'}`}/>
                    </Form.Item>
                  </div>
                  <div className="more-xia">
                    <Form.Item label="期&nbsp;&nbsp;数" arrow={false} onClick={() => {setVisible(true)}}>
                      <Input readOnly placeholder='请选择期数' value={val[1]?`${val[1]}期`:''}/>
                    </Form.Item>
                  </div>
                </Form>
              </div>
            </div>
          </header>
          <section>
            {
              (calObj && isShow) && <div className="content-box">
                <div className="header-title">
                  <div className="header-text">
                    <p className="dotted-line">金融方案</p>
                    <span>此数据仅以分期裸价为计算结果，最终结果以终审结果为准。</span>
                  </div>
                </div>
                <div className="section-content">
                  <ul>
                    <li>
                      <div className="content-label">首付：</div>
                      <div className="conent-value">{calObj?.firstPrice}元</div>
                    </li>
                    <li>
                      <div className="content-label">分期金额：</div>
                      <div className="conent-value">{calObj?.stagingPrice}元</div>
                    </li>
                    <li>
                      <div className="content-label">期数：</div>
                      <div className="conent-value">{calObj?.stagingTime}期</div>
                    </li>
                    <li>
                      <div className="content-label">月租：</div>
                      <div className="conent-value">{calObj?.monthlyRent}元</div>
                    </li>
                    <li><p>放款前需缴纳的费用</p></li>
                    <li>
                      <div className="content-label">手续费：</div>
                      <div className="conent-value">{calObj?.handlingFee}元</div>
                    </li>
                    <li>
                      <div className="content-label"><div>履约保证金：</div><span>(结清可退还)</span></div>
                      <div className="conent-value">{calObj?.PerFormAnceBond}元</div>
                    </li>
                    <li><p>放款前需在ZEEHO APP购买</p></li>
                    <li>
                      <div className="content-label">骑行意外险：</div>
                      <div className="conent-value">{calObj?.accidentInsurance}元</div>
                    </li>
                    <li>
                      <div className="content-label">盗抢保障费用：</div>
                      <div className="conent-value">{calObj?.robberyProtectionFee}元</div>
                    </li>
                  </ul>
                </div>
              </div>
            }

          </section>
          {(calObj && isShow) && <footer>
            <div className="page-footer">
              <div onClick={quaResult} className="button-them upload-next">
                资格预审
              </div>
            </div>
            <BottomIcon />

          </footer>}
        </div>
        <PickerPopup
          visible={visible}
          setVisible={setVisible}
          value={val}
          carPrice={carPrice}
          setVal={setVal}
          />
      </CustomScroll>
      {(!calObj || !isShow) && (<footer>
        <div className="page-footer">
          <div onClick={quaResult} className="button-them upload-next">
            资格预审
          </div>
        </div>
        <BottomIcon />
      </footer>
      )}
    </div>
  )
}

export default memo(Calculator);